import React from 'react'
import { Link } from 'react-router-dom';
const MainArea = () => {
    // const obj= MainAreaObject.object;
    const obj = [
        {
            id: 1,
            img: 'assets/img/1.webp',
            alt: 'Avtar',
            heading: 'Powerpoint',
            content: 'We work on Website and Mobile App.',
            redirect_link: '/power-points'
        },
        {
            id: 2,
            img: 'assets/img/portfolio/CRM-Fixfilla-a.webp',
            alt: 'Avtar',
            heading: 'CRM Fixfella',
            content: 'We work on Website & Mobile App',
            redirect_link: '/crm-fixfella'
        },
        {
            id: 3,
            img: 'assets/img/portfolio/bluetooth-a.webp',
            alt: 'Avtar',
            heading: 'Listen & Heard',
            content: 'We work on Website & Mobile App',
            redirect_link: '/bluetooth'
        },
        {
            id: 4,
            img: 'assets/img/portfolio/Mesee-a.webp',
            alt: 'Avtar',
            heading: 'Mesee',
            content: 'We work on Website & Mobile App',
            redirect_link: '/mesee-project'
        },
        {
            id: 5,
            img: 'assets/img/portfolio/john-bull-a.webp',
            alt: 'Avtar',
            heading: 'Johnbull',
            content: 'Architect & Engineer',
            redirect_link: '/johnbull-project'
        },
        {
            id: 6,
            img: 'assets/img/portfolio/krista-a.webp',
            alt: 'Avtar',
            heading: 'Challenger App',
            content: 'We work on Website & Mobile App',
            redirect_link: '/krista-project'
        },
        {
            id: 7,
            img: 'assets/img/portfolio/junk-removal-front.webp',
            alt: 'Avtar',
            heading: 'Junk Removal',
            content: 'We work on Website & Mobile App',
            redirect_link: '/junk-removal'
        },
        {
            id: 8,
            img: 'assets/img/portfolio/dash-global.webp',
            alt: 'Avtar',
            heading: 'Dash-Global',
            content: 'We work on Website & Mobile App',
            redirect_link: '/dash-global'
        },
    ]
    return (
        <>
            <section className="mt-40" style={{ marginTop: "40px", marginBottom: "40px" }}>
                <div className="container services-details">
                    <div className="section-title row" style={{ marginBottom: "30px" }}>
                        <div className='col-lg-4'></div>
                        <div className='col-lg-4 mb-3'>
                            <h2 style={{ paddingBottom: "0" }}>Our Products</h2>
                            <div className="bar"></div>
                        </div>
                        <div className='portfolio-download col-lg-4'>
                            <a href="./assets/portfolio.pdf"
                                title='Download Our Portfolio Pdf' target='_blank' download>Download Our Portfolio <i className="fa fa-download" aria-hidden="true"></i></a>
                        </div>
                    </div>
                    <div className="row">
                        {obj.map((box) => {
                            return <div className="col-md-6 col-lg-3 mt-3" key={box.id}>
                                <div className="card-a">
                                    <div className="flip-card">
                                        <div className="flip-card-inner">
                                            <img src={box.img} alt={box.alt} />
                                            <div className="flip-card-back top-tag">
                                                <h2>{box.heading}</h2>
                                                <p>{box.content}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body text-center">
                                        <h5 className="card-title">{box.heading}</h5>
                                        <Link to={box.redirect_link} className="btn btn-primary btn-details">Details</Link>
                                    </div>
                                </div>
                            </div>
                        })}


                    </div>
                </div>
            </section>
        </>
    )
}

export default MainArea